import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { navLinks } from '@content/navLinks';
import { NavLink } from 'react-router-dom';
import { RESERVATION_URL } from '@/content/reservation';
import { strings } from '@/i18n/strings';
import { Button } from '@components/__shared/Button/Button';
import styles from './Nav.module.scss';

const OPEN_CHROME_COLOR = '#12161d';

export const Nav = () => {
	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);

	useEffect(() => {
		if (!isOpen) return;

		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';

		const themeColor = document.querySelector('meta[name="theme-color"]');
		const previousChrome = themeColor?.getAttribute('content') ?? null;
		themeColor?.setAttribute('content', OPEN_CHROME_COLOR);

		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape') setIsOpen(false);
		};
		window.addEventListener('keydown', onKeyDown);

		return () => {
			document.body.style.overflow = previousOverflow;
			if (previousChrome !== null) themeColor?.setAttribute('content', previousChrome);
			window.removeEventListener('keydown', onKeyDown);
		};
	}, [isOpen]);

	const renderLinks = (sheet: boolean) =>
		navLinks.map(link => (
			<NavLink
				key={link.to}
				to={link.to}
				end={link.to === '/'}
				className={({ isActive }) =>
					classNames(styles.link, sheet && styles.linkSheet, isActive && styles.linkActive)
				}
				onClick={close}
			>
				{link.label}
			</NavLink>
		));

	const reserve = (className?: string) => (
		<Button
			variant="accent"
			href={RESERVATION_URL}
			target="_blank"
			rel="noreferrer"
			className={classNames(styles.cta, className)}
			onClick={close}
		>
			{strings.nav.reserve}
		</Button>
	);

	return (
		<nav className={styles.nav}>
			<div className={styles.links}>
				{renderLinks(false)}
				{reserve()}
			</div>

			<button
				type="button"
				className={classNames(styles.toggle, isOpen && styles.toggleOpen)}
				aria-label={isOpen ? strings.nav.closeMenu : strings.nav.openMenu}
				aria-expanded={isOpen}
				aria-controls="mobile-menu"
				onClick={() => setIsOpen(open => !open)}
			>
				<span className={styles.toggleBox} aria-hidden="true">
					<span className={styles.toggleBar} />
					<span className={styles.toggleBar} />
					<span className={styles.toggleBar} />
				</span>
			</button>

			<div id="mobile-menu" className={classNames(styles.sheet, isOpen && styles.sheetOpen)} inert={!isOpen}>
				<div className={styles.sheetInner}>
					{renderLinks(true)}
					{reserve(styles.ctaSheet)}
				</div>
			</div>
		</nav>
	);
};
